import React from 'react'
import PropTypes from 'prop-types'
import {Form, Field} from 'formik'
import {
  Flex,
  Text,
  Button,
  Select,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import FormField from '~/react/components/FormField'
import {EmailIcon} from '~/react/icons'

const PersonalInformationStep = ({
  isValid,
  isSubmitting,
  onNext,
  onBack,
  onCancel,
}) => {
  const {t} = useTranslation('points')

  return (
    <Form>
      <Flex direction="column" gap="md">
        <Text textStyle="body-small" color="gray.600">
          {t('points:connectionDrawer.steps.personalInfo.description')}
        </Text>

        <Field name="title">
          {({field, form: {errors: formErrors, touched: formTouched}}) => (
            <FormControl isInvalid={formErrors.title && formTouched.title}>
              <Text textStyle="body-small" mb="xs">
                {t('points:connectionDrawer.fields.title.label')}
              </Text>
              <Select
                {...field}
                placeholder={t(
                  'points:connectionDrawer.fields.title.placeholder',
                )}
              >
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
                <option value="Prof">Prof</option>
                <option value="Hon">Hon</option>
                <option value="Sen">Sen</option>
              </Select>
              <FormErrorMessage>{formErrors.title}</FormErrorMessage>
            </FormControl>
          )}
        </Field>

        <FormField
          type="text"
          name="firstName"
          label={t('points:connectionDrawer.fields.firstName.label')}
          placeholder={t(
            'points:connectionDrawer.fields.firstName.placeholder',
          )}
        />

        <FormField
          type="text"
          name="lastName"
          label={t('points:connectionDrawer.fields.lastName.label')}
          placeholder={t('points:connectionDrawer.fields.lastName.placeholder')}
        />

        <FormField
          type="email"
          name="email"
          label={t('points:connectionDrawer.fields.email.label')}
          placeholder={t('points:connectionDrawer.fields.email.placeholder')}
          icon={<EmailIcon />}
        />

        <FormField
          type="tel"
          name="phoneNumber"
          label={t('points:connectionDrawer.fields.phoneNumber.label')}
          placeholder={t(
            'points:connectionDrawer.fields.phoneNumber.placeholder',
          )}
        />

        <Flex justify="space-between" mt="md">
          <Flex gap="sm">
            <Button variant="primary" onClick={onCancel}>
              {t('points:connectionDrawer.buttons.cancel')}
            </Button>
            <Button variant="secondary" onClick={onBack}>
              {t('points:connectionDrawer.buttons.back')}
            </Button>
          </Flex>
          <Button
            variant="primary"
            colorScheme="primary"
            onClick={onNext}
            isDisabled={!isValid || isSubmitting}
            isLoading={isSubmitting}
          >
            {t('points:connectionDrawer.buttons.next')}
          </Button>
        </Flex>
      </Flex>
    </Form>
  )
}

PersonalInformationStep.propTypes = {
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default PersonalInformationStep
